export enum UserPermissionEnum {
  UserRead = 'user_read',
  UserManage = 'user_manage',
  UserBlock = 'user_block',

  RoleRead = 'role_read',
  RoleManage = 'role_manage',

  PoolRead = 'pool_read',
  PoolManage = 'pool_manage',

  ManufacturerRead = 'manufacturer_read',
  ManufacturerManage = 'manufacturer_manage',

  EquipmentRead = 'equipment_read',
  EquipmentManage = 'equipment_manage',
  EquipmentModelRead = 'equipment_model_read',
  EquipmentModelManage = 'equipment_model_manage',
  EquipmentEventRead = 'equipment_event_read',

  FirmwareRead = 'firmware_read',
  FirmwareManage = 'firmware_manage',

  FacilityRead = 'facility_read',
  FacilityManage = 'facility_manage',

  ContainerRead = 'container_read',
  ContainerManage = 'container_manage',

  WorkerRead = 'worker_read',
  WorkerManage = 'worker_manage',

  MaintenanceRead = 'maintenance_read',
  MaintenanceManage = 'maintenance_manage',

  AuditRead = 'audit_read',

  // Scanner & Agent management (new)
  AgentRead = 'agent_read',
  AgentManage = 'agent_manage',
  ScansRead = 'scans_read',
  ScansManage = 'scans_manage',
}
